import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
export type UpgradeModalVariant = 'welcome' | 'free_scan_complete' | 'no_credits' | 'plans';
interface UpgradeModalContextType {
  variant: UpgradeModalVariant | null;
  isOpen: boolean;
  openUpgradeModal: (variant: UpgradeModalVariant) => void;
  closeUpgradeModal: () => void;
}
const UpgradeModalContext = createContext<UpgradeModalContextType | undefined>(undefined);
export function UpgradeModalProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [variant, setVariant] = useState<UpgradeModalVariant | null>(null);
  const openUpgradeModal = useCallback((next: UpgradeModalVariant) => {
    setVariant(next);
  }, []);
  const closeUpgradeModal = useCallback(() => {
    setVariant(null);
  }, []);
  const value = useMemo(() => ({
    variant,
    isOpen: variant !== null,
    openUpgradeModal,
    closeUpgradeModal
  }), [variant, openUpgradeModal, closeUpgradeModal]);
  return <UpgradeModalContext.Provider value={value} data-id="element-3040" data-mp="1rbe92fbf6x1m">
      {children}
    </UpgradeModalContext.Provider>;
}
/**
 * Non-throwing accessor. The statically served marketing entry points render
 * without this provider.
 */
export function useOptionalUpgradeModal() {
  return useContext(UpgradeModalContext);
}
export function useUpgradeModal() {
  const context = useContext(UpgradeModalContext);
  if (context === undefined) {
    throw new Error('useUpgradeModal must be used within an UpgradeModalProvider');
  }
  return context;
}